import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, EndpointService } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { Dependencia, DocumentoDependencia } from '@app/shared';


@Injectable()
export class DocumentDependencyDataService {

  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService, private as: AuthenticationService) { }


    /**
   * Obtener id de la empresa según usuario logueado
   *
   * @returns
   * @memberof ManagementSystemDataService
   */
     idSelectCompany() {
      return this.as.getCredentials(true).info_persona.id_empresa;
    }

  /**
   * Agregar una dependencia por estructura documental
   *
   * @param {FormData} documentDependency
   * @returns {Promise<boolean>}
   * @memberof DocumentDependencyDataService
   */
  addDocumentDependency(documentDependency: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminDocumentDependency'),
      documentDependency).subscribe(
        _resp => {
          this.toastr.success('Dependencia documental agregada correctamente','Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', 'Información incompleta');
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Modificar una dependencia por estructura documental
   *
   * @param {number} id
   * @param {any} documentDependency
   * @returns {Promise<boolean>}
   * @memberof DocumentDependencyDataService
   */
  updateDocumentDependency(id: number, documentDependency: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminDocumentDependency', [id]), documentDependency).subscribe(
        _resp => {
          this.toastr.success('Registro modificado correctamente','Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', 'Información incompleta');
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Eliminar una dependencia por estructura documental
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof DocumentDependencyDataService
   */
  deleteDocumentDependency(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('adminDocumentDependency', [id])).subscribe(
        _resp => {
          this.toastr.success('Registro eliminado correctamente','Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', err);
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }


    /**
   * Consulta las dependencias documentales.
   *
   * @returns {Observable<DocumentoDependencia[]>}
   * @memberof DocumentDependencyDataService
   */
     getDocumentDependency(): Observable<DocumentoDependencia[]> {
      return this.http.get<DocumentoDependencia[]>(this.api.get('adminDocumentDependency'));
    }

    /**
   * Consulta las dependencias.
   * 
   * @param {any} idCompany
   * @returns {Observable<Dependencia[]>}
   * @memberof DocumentDependencyDataService
   */
     getDependency(idCompany:any): Observable<Dependencia[]> {
      return this.http.get<Dependencia[]>(this.api.get('sedesManagement',[idCompany]));
    }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-dependency/shared/document-dependency-data.service.ts